import { useEffect, useState } from 'react';
import minor_5 from '../assets/symbols/info_minor_5.png';
import minor_4 from '../assets/symbols/info_minor_4.png';
import minor_3 from '../assets/symbols/info_minor_3.png';
import minor_2 from '../assets/symbols/info_minor_2.png';
import minor_1 from '../assets/symbols/info_minor_1.png';
import major_5 from '../assets/symbols/info_major_5.png';
import major_4 from '../assets/symbols/info_major_4.png';
import major_3 from '../assets/symbols/info_major_3.png';
import major_2 from '../assets/symbols/info_major_2.png';
import major_1 from '../assets/symbols/info_major_1.png';
import scatter from '../assets/symbols/info_scatter.png';
import wild from '../assets/symbols/info_wild.png';

const ICONS = [
	minor_5,
	minor_4,
	minor_3,
	minor_2,
	minor_1,
	major_5,
	major_4,
	major_3,
	major_2,
	major_1,
	scatter,
	wild
];

export default function useCoefData(coefs) {
	const [data, setData] = useState(null);
	useEffect(() => {
		const arr = [];
		//TODO reverse this arr
		for (let i = 0; i < coefs.coeffs.length - 1; i++) {
			const element = {
				id: i,
				icon: ICONS[i],
				coef: coefs.coeffs[i].coeffs
			};
			arr.unshift(element);
		}
		setData(arr);
	}, [coefs]);

	return [data];
}
